module.exports = __webpack_public_path__ + "img/4D595E_858D87_596F84_748480-256px.04469fe0.png";